import { api } from "@/comn";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { lpcoEnvs, lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn"; // 시스템 공통 유틸
import { TFormSchema, TGridSchema } from "@/comn/hooks";

import { COMN_SF_LPCO_SRCH, COMN_SG_LPCO_LIST_HEAD, COMN_SG_LPCO_LIST_BODY } from "@/tz/go/egaz/osci/lpco/cfgn/comn";

/*
 *  LPCO Component Settings
 * !== LPCO Component Service ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${lpcoEnvs.base}/lpco/cfgn/prcs`,
    api: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/cfgn/prcs`,
    nodes: [
        { path: "/lpco/cfgn/cpnt/osci0203017s", label: "T_LPCO" },
        { path: "/lpco/cfgn/cpnt/osci0203017s", label: "T_CFGN" },
        { path: "/lpco/cfgn/cpnt/osci0203017s", label: "T_LPCO_APP_SETT" },
        { path: "/lpco/cfgn/prcs/osci0203009s", label: "T_PRCS_SETT" },
    ],
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    osci0203009s: `${BASE.path}/osci0203009s`, // Register LPCO Process   !== LPCO 처리 프로세스 등록 등록  ==!
    osci0203010q: `${BASE.path}/osci0203010q`, // Register LPCO Process List  !== LPCO 처리 프로세스 구성 목록 조회  ==!
    osci0203011s: `${BASE.path}/osci0203011s`, // Register LPCO Process Detail  !== LPCO 처리 프로세스 구성 상세 조회  ==!
    osci0203012s: `${BASE.path}/osci0203012s`, // LPCO Process Modification  !== LPCO 처리 프로세스 수정 ==!
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    /* LPCO Component list inquiry !== LPCO Component 목록 조회 ==! */
    getLpcoList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    /* LPCO detailed inquiry !== LPCO Component 상세 조회 ==! */
    getAppDtl: (prcsMnId: any) => {
        return api.get(`${BASE.api}/${prcsMnId}`);
    },
    createAppPrcs: (data: any) => {
        console.log(" saveAppPrcs :: ", data);
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },
    /* Register LPCO information !== LPCO Component 등록 ==! */
    saveAppPrcs: (prcsMnId: any, data: any) => {
        return api.put(`${BASE.api}/${prcsMnId}`, {
            ...data,
        });
    },
    /* Delete LPCO Process !== LPCO Process 삭제 ==! */
    deleteAppPrcs: (prcsMnId: any) => {
        return api.delete(`${BASE.api}/${prcsMnId}`, {});
    },
    /* Process configuration parameters !== 프로세스 설정 파라미터 조회 ==! */
    getPrcsPrmt: () => {
        return api.get(`${BASE.api}/prmt`);
    },
    getDefaultAppProcess(appTpCd: string, paramOrgCd: string) {
        const arrDefaultPrcsStatCd = ["VE", "VA", "IP", "FR"];
        const arrExmpnPrcsStatCd = ["VE", "VA", "IP", "FR", "EV", "ES", "EF"];

        let arrDefaultProcess: any[] = [];
        let arrPrcs = [...arrDefaultPrcsStatCd];
        if (appTpCd == "EA") {
            arrPrcs = [...arrExmpnPrcsStatCd];
        }
        arrDefaultProcess = arrPrcs.map((val, idx) => {
            let orgCd = "";
            if (val != "SU" && val != "AP") {
                orgCd = paramOrgCd;
            }
            if (["EV", "ES", "EF"].indexOf(val) > -1) {
                orgCd = lpcoEnvs.ORG_CD_TRA;
            }
            return {
                prcsRoleTpCd: val,
                prcsRoleDesc: PRCS_DESC[val],
                orgCd: orgCd,
            };
        });
        return arrDefaultProcess;
    },
};

export const PRCS_DESC: any = {
    SU: "This stage is where the applicant sends the application after filling it out.",
    VE: "This stage is where the Checking Officer proceeds with verification.",
    IP: "This stage is where the Inspection Officer proceeds with verification.",
    FP: "This stage is where the fee is calculated, and the bill is issued and paid.",
    FR: "This stage is where the Final Approval Officer proceeds with verification.",
    AP: "This stage is where the application gets final approval, and this is the final stage that ends the Process.",
    EV: "This stage is where the Exemption Application Review Officer proceeds with verification.",
    EF: "This stage is where the Exemption Application Final Approval Officer proceeds with verification.",
    ES: "This stage is where the Exemption Application Verfication Approval Officer proceeds with verification.",
    VA: "This stage is where the Verification Officer proceeds with verification.",
    FC: "This stage is where the fee is calculated, and the combined bill is issued and paid.", // 2025-04-20 Roy Add Combined bill stage !== 통합 고지서 단계 추가 ==!
};

export const GRID_DEFAULT_DATA = [
    {
        prcsRoleTpCd: "SU",
        prcsRoleDesc: PRCS_DESC.SU,
    },
    {
        prcsRoleTpCd: "AP",
        prcsRoleDesc: PRCS_DESC.AP,
    },
];

/*
 * @ Form 스키마 정의
 * @ 화면에서 사용하는 Form 구조 정의
 * @ SF_ 로 시작 (Schema form)
 * @ SF_[Form 이름 메타 대문자, "_" 로 구분 ]
 * @ 검색폼은 _SRCH 로 구분
 */
/**
 * Component Setting > Register LPCO Components
 */
// LPCO Component Schema !== LPCO Component ==!
export const SF_LPCO_INFO_R: TFormSchema = {
    id: "form_LpcoInfo",
    schema: {
        orgCd: {
            type: "text",
            label: "L_OGA",
            controlSize: 10,
            edit: false,
        } /* OGA */,
        orgNm: { type: "text", label: "L_OGA", edit: false } /* OGA Name */,
        appCdNo: {
            type: "select",
            label: "L_LPCO",
            required: true,
            edit: false,
        } /* L_LPCO */,
        appNm: {
            type: "text",
            label: "L_LPCO",
            required: true,
            edit: false,
        } /* L_LPCO */,
        appTpCd: {
            type: "select",
            label: "L_APP_TP",
            area: "comnCd",
            comnCd: "OSC0113",
            viewType: "label",
            edit: false,
        },
        lpcoAplyTpCd: {
            type: "select",
            label: "L_LPCO_APLY_TP",
            area: "comnCd",
            comnCd: "OSC0143",
            required: true,
            edit: false,
        },
        appdDt: {
            type: "daterange",
            label: "L_VLD_PRID",
            edit: false,
            start: { name: "appdStrtDt", required: true },
            end: {
                name: "appdEndDt",
                required: true,
                // value : 종료일자의 값 , formValues : 폼의 값들
                validate: (value: any, formValues: any) => {
                    // 종료일자와 시작일자를 비교하여 오류검증 실행
                    // formValues.startDate 처럼 시작일자(startDate) 필드를 지정해서 비교
                    return comnUtils.dateDiff(value, formValues.appdStrtDt) < 0 ? "msg.osc.00049" : true;
                },
            },
            required: true,
            controlSize: 10,
        },
        appdStrtDt: {
            type: "date",
            label: "L_VLD_STRT_DT",
            edit: false,
        } /* Valid Start Date */,
        appdEndDt: {
            type: "date",
            label: "L_VLD_END_DT",
            edit: false,
        } /* Valid End Date */,
    },
};

export const SF_LPCO_INFO_U: TFormSchema = {
    id: "form_LpcoInfo",
    schema: {
        orgCd: {
            type: "text",
            label: "L_OGA",
            controlSize: 10,
            edit: false,
        } /* OGA */,
        orgNm: { type: "text", label: "L_OGA", edit: false } /* OGA Name */,
        appCdNo: {
            type: "select",
            label: "L_LPCO",
            edit: true,
            required: true,
        } /* L_LPCO */,
        appNm: {
            type: "text",
            label: "L_LPCO",
            edit: false,
            controlSize: 10,
        } /* L_LPCO */,
        appTpCd: {
            type: "select",
            label: "L_APP_TP",
            area: "comnCd",
            comnCd: "OSC0113",
            viewType: "label",
            edit: false,
        },
        lpcoAplyTpCd: {
            type: "select",
            label: "L_LPCO_APLY_TP",
            area: "comnCd",
            comnCd: "OSC0143",
            edit: true,
            required: true,
        },
        appdDt: {
            type: "daterange",
            label: "L_VLD_PRID",
            start: { name: "appdStrtDt", required: true },
            end: {
                name: "appdEndDt",
                required: true,
                // value : 종료일자의 값 , formValues : 폼의 값들
                validate: (value: any, formValues: any) => {
                    // 종료일자와 시작일자를 비교하여 오류검증 실행
                    // formValues.startDate 처럼 시작일자(startDate) 필드를 지정해서 비교
                    return comnUtils.dateDiff(value, formValues.appdStrtDt) < 0 ? "msg.osc.00049" : true;
                },
            },
            required: true,
            controlSize: 10,
        },
        appdStrtDt: {
            type: "date",
            label: "L_VLD_STRT_DT",
            required: true,
        } /* Valid Start Date */,
        appdEndDt: {
            type: "date",
            label: "L_VLD_END_DT",
            required: true,
        } /* Valid End Date */,
    },
};

/*
 * @ 그리드 스키마 정의
 * @ 화면에서 사용하는 그리드 구조 정의
 * @ SG_ 로 시작 (Schema grid)
 * @ SG_[그리드명가 조회하는 데이터 이름 메타 단어(용어) 대문자, "_" 로 구분 , 그리드명 맨 뒤에 "_LIST" 로 종료]
 */

/**
 * Component Setting > LPCO LIST
 */
// LPCO Component Search Schema !== LPCO Component Search  ==!
export const SF_LPCO_SRCH: TFormSchema = {
    id: "form_LpcoSrch",
    schema: {
        ...COMN_SF_LPCO_SRCH,
        srchLpcoAplyTpCd: {
            type: "select",
            label: "L_LPCO_APLY_TP",
            area: "comnCd",
            comnCd: "OSC0143",
            edit: true,
        } /* Application Type */,
    },
};

// LPCO Settings List Grid Schema !== LPCO 설정 목록 그리드 스키마 ==!
export const SG_LPCO_LIST_R: TGridSchema = {
    id: "grid_lpcoList",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: false, //체크박스 보이기 숨기기, default : false
        pagination: "out", // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        add: false, // add 버튼 보이기/숨기기 , default : false
        delete: false, // delete 버튼 보이기/숨기기 , default : false
        edit: false, // 그리드 편집 가능 여부 , default : false
        height: 480,
    },
    head: [
        ...COMN_SG_LPCO_LIST_HEAD,
        { cells: [{ header: "L_USE_YN", binding: "useYn", width: 80 }] } /* Use Yn */,
        { cells: [{ header: "L_LPCO_APLY_TP", binding: "lpcoAplyTpCd", width: "*" }] },
        { cells: [{ header: "L_CMBI_BLL_YN", binding: "cmbiBllYn", width: 90 }] },
        { cells: [{ header: "L_VLD_STRT_DT", binding: "appdStrtDt", width: 130 }] },
        { cells: [{ header: "L_VLD_END_DT", binding: "appdEndDt", width: 130 }] },
    ],
    body: [
        ...COMN_SG_LPCO_LIST_BODY,
        {
            cells: [
                {
                    binding: "useYn",
                    align: "center",
                    area: "comnCd",
                    comnCd: "OSC0101",
                    type: "select",
                    viewType: "value",
                },
            ],
        },
        { cells: [{ binding: "lpcoAplyTpCd", type: "select", comnCd: "OSC0143", area: "comnCd", viewType: "label" }] },
        { cells: [{ binding: "cmbiBllYn" }] },
        { cells: [{ binding: "appdStrtDt", type: "date" }] },
        { cells: [{ binding: "appdEndDt", type: "date" }] },
    ],
};

/**
 * LPCO COMPONENT DETAIL
 */

// LPCO Component Schema !== LPCO Component ==!
export const SG_LPCO_PRCS_LIST_U: TGridSchema = {
    id: "grid_cpntRList",
    options: {
        radio: true, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: false, //체크박스 보이기 숨기기, default : false
        pagination: false, // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        add: false, // add 버튼 보이기/숨기기 , default : false
        delete: false, // delete 버튼 보이기/숨기기 , default : false
        edit: true, // 그리드 편집 가능 여부 , default : false
        height: 420,
    },
    head: [
        { cells: [{ header: "L_PRCS_CFGN_CD", binding: "prcsRoleTpCd", width: "*" }] } /* Process Name */,
        // { cells: [{ header: "L_OGA", binding: "orgCd", width: "*" }], id: "orgCd" },
        { cells: [{ header: "L_DESC", binding: "prcsRoleDesc", width: "*" }] } /* Descriptions */,
    ],
    body: [
        {
            cells: [
                {
                    binding: "prcsRoleTpCd",
                    align: "left",
                    type: "select",
                    comnCd: "OSC0120",
                    area: "comnCd",
                    edit: true,
                    required: true,
                },
            ],
        },
        // { cells: [{ binding: "orgCd", align: "left", type: "text", edit: true, disabled: true }] },
        { cells: [{ binding: "prcsRoleDesc", align: "left", type: "text", edit: true, maxLength: 2000 }] },
    ],
};

/*
 * @ 그리드 스키마 정의
 * @ 화면에서 사용하는 그리드 구조 정의
 * @ SG_ 로 시작 (Schema grid)
 * @ SG_[그리드명가 조회하는 데이터 이름 메타 단어(용어) 대문자, "_" 로 구분 , 그리드명 맨 뒤에 "_LIST" 로 종료]
 */

// LPCO Settings List Grid Schema !== LPCO 설정 목록 그리드 스키마 ==!
export const SG_LPCO_PRCS_LIST_R: TGridSchema = {
    id: "grid_cpntRList",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: false, //체크박스 보이기 숨기기, default : false
        pagination: false, // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        add: false, // add 버튼 보이기/숨기기 , default : false
        delete: false, // delete 버튼 보이기/숨기기 , default : false
        edit: false, // 그리드 편집 가능 여부 , default : false
        height: 400,
    },
    head: [
        { cells: [{ header: "L_PRCS_CFGN_CD", binding: "prcsRoleTpCd", width: "*" }] } /* Process Name */,
        // { cells: [{ header: "L_OGA", binding: "orgNm", width: "*" }], id: "orgNm" },
        { cells: [{ header: "L_DESC", binding: "prcsRoleDesc", width: "*" }] } /* Descriptions */,
    ],
    body: [
        {
            cells: [
                {
                    binding: "prcsRoleTpCd",
                    align: "left",
                    type: "select",
                    comnCd: "OSC0120",
                    area: "comnCd",
                    edit: false,
                    viewType: "label",
                },
            ],
        },
        // { cells: [{ binding: "orgNm", align: "left", type: "text", edit: false }] },
        { cells: [{ binding: "prcsRoleDesc", align: "left", type: "text", edit: false }] },
    ],
};

// Add electronic approval column to process grid schema !== 프로세스 그리드 스키마에 전자결재 컬럼 추가 ==!
export const withAprvColumn = (schema: TGridSchema, edit: boolean): TGridSchema => ({
    ...schema,
    head: [...schema.head, { cells: [{ header: "L_APRV_YN", binding: "aprvExisYn", width: 120 }] }],
    body: [
        ...schema.body,
        {
            cells: [
                {
                    binding: "aprvExisYn",
                    align: "center",
                    type: "select",
                    area: "comnCd",
                    comnCd: "OSC0101",
                    edit: edit,
                    viewType: edit ? "both" : "label",
                },
            ],
        },
    ],
});
